import React from "react";
import { useLocation } from "react-router-dom";

const AccountDeletion = () => {
    const location = useLocation();
    const isBlankLayout = location.pathname === "/account-deletion";

    if (isBlankLayout) {
        return (
            <div className="py-5 px-4">
                {/* Title */}
                <h4 className="mb-4 fw-bold fs-3">Account Deletion Instructions</h4>

                {/* Intro paragraph */}
                <p className="mb-5 fs-6">
                    If you want to delete your activities for Lea.Training App, you can
                    remove your account by following these steps:
                </p>

                {/* Step 1 */}
                <div className="mb-5">
                    <p className="fs-6 mb-3">
                        1. Launch the app: Open the app on your device.
                    </p>
                    <img
                        src="/assets/img/account-deletion/splash_screen.png"
                        alt="Step 1 - Open the app"
                        className="img-fluid rounded shadow-sm d-block"
                        style={{ maxWidth: "220px", marginBottom: "1rem" }}
                    />
                </div>

                {/* Step 2 */}
                <div className="mb-5">
                    <p className="fs-6 mb-3">
                        2. Login screen: If you're not already logged in, you should see a sign-in screen.
                        Enter your credentials (phone number and password) or (email and password) to log into your
                        account.</p>
                    <img
                        src="/assets/img/account-deletion/login_screen.png"
                        alt="Step 1 - Open the app"
                        className="img-fluid rounded shadow-sm d-block"
                        style={{ maxWidth: "220px", marginBottom: "1rem" }}
                    />
                </div>
                <div className="mb-5">
                    <p className="fs-6 mb-3">
                        3. Look for the account icon on the screen. It might be represented by avatar, a person icon. Tap or click on the account icon to open the menu.
                    </p>
                    <img
                        src="/assets/img/account-deletion/home_screen.png"
                        alt="Step 1 - Open the app"
                        className="img-fluid rounded shadow-sm d-block"
                        style={{ maxWidth: "220px", marginBottom: "1rem" }}
                    />
                </div>
                <div className="mb-5">
                    <p className="fs-6 mb-3">
                        4. Locate to account deletion option: Within the account screen, related to account deletion. The option named "Delete Profile," Tap on it to proceed.
                    </p>
                    <img
                        src="/assets/img/account-deletion/delete_account_screen.png"
                        alt="Step 1 - Open the app"
                        className="img-fluid rounded shadow-sm d-block"
                        style={{ maxWidth: "220px", marginBottom: "1rem" }}
                    />
                </div>
                <div className="mb-5">
                    <p className="fs-6 mb-3">
                        5. Confirmation prompt: After selecting the account deletion option, the app will display a confirmation screen informing you that your account will be permanently unusable, cannot be re-registered, and that this action is irreversible. You must agree to the Terms and Conditions and Privacy Policy before proceeding.
                    </p>
                    <img
                        src="/assets/img/account-deletion/delete_account_screen_dialouge.png"
                        alt="Step 1 - Open the app"
                        className="img-fluid rounded shadow-sm d-block"
                        style={{ maxWidth: "220px", marginBottom: "1rem" }}
                    />
                </div>
                <div className="mb-5">
                    <p className="fs-6 mb-3">
                        6. And done your account as well as your all data deleted successfully.
                    </p>
                </div>
            </div>
        );
    }

    return null;
};

export default AccountDeletion;